<template>
    <div class="col-lg clr-2 py-4 clr2">
		<h1 class="py-3 px-5 display-4 text-light">Trading Center</h1>
		<div class="input-group mb-3">
			<div class="input-group-prepend">
				<span class="input-group-text" id="basic-addon1">Search</span>
			</div>
			<input type="text" class="form-control" v-model="search" aria-describedby="basic-addon1">
		</div>
	</div>
	<div id="stockDisplay">
		<Stock 	v-for="stock in stocksSearched"  :key="stock" class="stock"
				:channel="this.stockDataBase[stock].channel" id="stock"
				:price="Math.round((((this.stockDataBase[stock].subs*0.676)+(this.stockDataBase[stock].viewLikeRatio-0.1)*5000000)/10000) * 100) / 100" 
				:change="Math.round((((this.stockDataBase[stock].subs*0.676)+(this.stockDataBase[stock].viewLikeRatio-0.1)*5000000)/10000-this.stockDataBase[stock].prevPrice) * 100) / 100" 
				:changePercent="Math.round((((((this.stockDataBase[stock].subs*0.676)+(this.stockDataBase[stock].viewLikeRatio-0.1)*5000000)/10000-this.stockDataBase[stock].prevPrice)/this.stockDataBase[stock].prevPrice)*100) * 100) / 100" 
				:logo="this.stockDataBase[stock].abbrev"
				:subs="this.stockDataBase[stock].subs" 
				:viewLikeRatio="Math.round(this.stockDataBase[stock].viewLikeRatio*100)/100"/>
	</div>
</template>
<script>
import Stock from '../components/Stock.vue'
import { getDatabase, ref, child, get, onValue} from "firebase/database";
export default {
	data() {
		return {
			stockDataBase: {},
			search: "",
			channels: []
		}
	},
	methods: {
	},
	computed: {
		stocksSearched() {
			if (this.search === "") {
				return this.channels
			} else {
				return this.channels.filter((channel) => channel.includes(this.search.toUpperCase()))
			}

		}
	},
	mounted() {
		const db = getDatabase()
		const stocksRef = ref(db, 'Stocks');
		onValue(stocksRef, (snapshot) => {
  			const data = snapshot.val();
  			this.stockDataBase= data;
			this.channels = Object.keys(this.stockDataBase)
		

		});

	},
	components: {
		Stock
	}
}
</script>
<style>
	#stockDisplay{
		display: flex;
		flex-flow: wrap;
		justify-content: left;
		background-color: #57AADE
	}
	.stock {
		padding-left: 50px;
		padding-right: 40px;
		padding-top: 50px;
		padding-bottom: 50px;
		margin-top: 50px;
		margin-left: 25px;
		margin-right: 25px;
		border-radius: 25px;
        border: 4px solid #292626;
		background-color: #292626;
	}
	.clr{
		background-color: #F8F9FA
	}
	.clr2{
		background-color: #2A6A91;
	}
	.wid{
		box-sizing: border-box;
	}
</style>

